import React from "react"
import RouterApp from "./router/RouterApp"

const App = () => {
  return <RouterApp />
}

export default App
